<script lang="ts">
    import slideGame1 from 'src/components/main/home/components/home-intro/slide-game-1.jpg'
    import slideGame1mobile from 'src/components/main/home/components/home-intro/slide-game-1-mobile.jpg'
    import slideGame2 from 'src/components/main/home/components/home-intro/slide-game-2.jpg'
    import slideGame2mobile from 'src/components/main/home/components/home-intro/slide-game-2-mobile.jpg'
    import slideGame3 from 'src/components/main/home/components/home-intro/slide-game-3.jpg'
    import slideGame3mobile from 'src/components/main/home/components/home-intro/slide-game-3-mobile.jpg'
    import googlePlay from 'src/components/main/home/components/home-intro/google-play.svg'
    import googlePlayInner from 'src/components/main/home/components/home-intro/google-play-inner.svg'
    import scroll from 'src/components/main/home/components/home-intro/scroll.svg'
    import IconifyIcon from '@iconify/svelte'
    import twitterIcon from '@iconify/icons-fa-brands/twitter'
    import telegramIcon from '@iconify/icons-fa-brands/telegram-plane'
    import discordIcon from '@iconify/icons-fa-brands/discord'
    import instagramIcon from 'src/components/#assets/instagram.svg'
    import { Swiper, SwiperSlide } from 'swiper/svelte'
    import { EffectFade } from 'swiper';
    import { Pagination } from 'swiper'
    import { Autoplay } from 'swiper'
    import 'swiper/css'
    import 'swiper/css/effect-fade';
    import 'swiper/css/pagination'
    import 'swiper/css/autoplay'
</script>

<section class="main-intro home-slider">
    <Swiper
        modules={[Pagination, Autoplay, EffectFade]}
        spaceBetween={12}
        slidesPerView={1}
        autoplay={{ delay: 6000 }}
        pagination={{ clickable: true }}
        effect="fade"
    >
        <SwiperSlide>
            <div class="slide slide-1" style="
                --SlideGame1:url({slideGame1});
                --SlideGame1mobile:url({slideGame1mobile});
            ">
                <div class="main-intro-content">
                    <div class="container">
                        <h1 class="intro-title"><span>Play.<br>Collect.<br>Earn.</span></h1>
                        <a href="https://play.google.com/store/apps/details?id=com.game.moba.realis.battle.royale" target="_blank" class="google-play">
                            <img src="{googlePlay}" alt="google play" class="d-none d-md-block">
                            <img src="{googlePlayInner}" alt="google play" class="d-md-none">
                        </a>
                        <div class="social-links">
<!--                            <a href="https://t.me/RealisANN" target="_blank">-->
<!--                                <IconifyIcon icon={telegramIcon}/>-->
<!--                            </a>-->
<!--                            <a href="https://twitter.com/realisnetwork" target="_blank">-->
<!--                                <IconifyIcon icon={twitterIcon}/>-->
<!--                            </a>-->
<!--                            <a href="https://discord.gg/realis" target="_blank">-->
<!--                                <IconifyIcon icon={discordIcon}/>-->
<!--                            </a>-->
<!--                            <a href="https://www.instagram.com/realis.network/" target="_blank">-->
<!--                                <img src={instagramIcon} class="instagram-icon" alt="">-->
<!--                            </a>-->
                        </div>
                        <a href="#game-cards" class="scroll">
                            <img src="{scroll}" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </SwiperSlide>
        <!--
        <SwiperSlide>
            <div class="slide slide-2" style="
                --SlideGame2:url({slideGame2});
                --SlideGame2mobile:url({slideGame2mobile});
            ">
                <div class="main-intro-content">
                    <div class="container">
                        <div class="intro-title"><span>Play.<br>Collect.<br>Earn.</span></div>
                        <a href="https://play.google.com/store/apps/details?id=com.dragons.tokens.crypto" target="_blank" class="google-play">
                            <img src="{googlePlay}" alt="google play" class="d-none d-md-block">
                            <img src="{googlePlayInner}" alt="google play" class="d-md-none">
                        </a>
                        <div class="social-links">
                            <a href="https://t.me/RealisANN" target="_blank">
                                <IconifyIcon icon={telegramIcon}/>
                            </a>
                            <a href="https://twitter.com/realisnetwork" target="_blank">
                                <IconifyIcon icon={twitterIcon}/>
                            </a>
                            <a href="https://discord.gg/realis" target="_blank">
                                <IconifyIcon icon={discordIcon}/>
                            </a>
                            <a href="https://www.instagram.com/realis.network/" target="_blank">
                                <img src={instagramIcon} class="instagram-icon" alt="">
                            </a>
                        </div>
                        <a href="#game-cards" class="scroll">
                            <img src="{scroll}" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </SwiperSlide>
        <SwiperSlide>
            <div class="slide slide-3" style="
                --SlideGame3:url({slideGame3});
                --SlideGame3mobile:url({slideGame3mobile});
            ">
                <div class="main-intro-content">
                    <div class="container">
                        <div class="intro-title"><span>Play.<br>Collect.<br>Earn.</span></div>
                        <a href="https://play.google.com/store/apps/details?id=com.soul.merge.cat.cute.simulator.adventure" target="_blank" class="google-play">
                            <img src="{googlePlay}" alt="google play" class="d-none d-md-block">
                            <img src="{googlePlayInner}" alt="google play" class="d-md-none">
                        </a>
                        <div class="social-links">
                            <a href="https://t.me/RealisANN" target="_blank">
                                <IconifyIcon icon={telegramIcon}/>
                            </a>
                            <a href="https://twitter.com/realisnetwork" target="_blank">
                                <IconifyIcon icon={twitterIcon}/>
                            </a>
                            <a href="https://discord.gg/realis" target="_blank">
                                <IconifyIcon icon={discordIcon}/>
                            </a>
                            <a href="https://www.instagram.com/realis.network/" target="_blank">
                                <img src={instagramIcon} class="instagram-icon" alt="">
                            </a>
                        </div>
                        <a href="#game-cards" class="scroll">
                            <img src="{scroll}" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </SwiperSlide>
        -->
    </Swiper>
</section>

<style>
    .slide {
        height: calc(100vh - 110px);
        position: relative;
        padding: 94px 0 0;
        margin-top: 110px;
        min-height: 870px;
    }

    .slide-1 {
        background: var(--SlideGame1) no-repeat center;
        background-size: cover;
    }

    .slide-2 {
        background: var(--SlideGame2) no-repeat center;
        background-size: cover;
    }

    .slide-3 {
        background: var(--SlideGame3) no-repeat center;
        background-size: cover;
    }

    .main-intro-content {
        position: relative;
        z-index: 2;
    }

    .main-intro-content .container {
        position: relative;
    }

    .before-title {
        font-size: 20px;
        line-height: 26px;
        color: white;
        border: 1px solid #FFFFFF;
        border-radius: 50px;
        display: inline-block;
        padding: 3px 15px;
        margin-bottom: 10px;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 110px;
        font-weight: 400;
        color: white;
        margin: 0 0 50px;
        line-height: 132px;
        text-transform: uppercase;
        letter-spacing: 0.2em;
    }

    .game-link img {
        max-width: 100%;
    }

    .game-reviews span {
        color: #515159;
        padding-left: 2px;
    }

    .slide :global(svg.star-icon) {
        font-size: 14px;
        color: #F3BD38;
        vertical-align: top !important;
        margin: 5px 0 0 0;
    }

    .slide :global(svg.star-icon:first-child) {
        margin-left: 5px;
    }

    .google-play {
        margin-bottom: 94px;
        display: table;
        position: relative;
        transition: .25s;
    }

    .google-play:after {
        content: "";
        border: 2px solid #A6A6A6;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border-radius: 10px;
        transition: .25s;
    }

    .google-play:hover:after {
        content: "";
        border-color: #3cdbc0;
    }

    .google-play:hover {
        transform: translateY(-10px);
    }

    .social-links {
        display: table;
    }

    .social-links a {
        color: white;
        margin-right: 50px;
        text-decoration: none;
        font-size: 30px;
        transition: .25s;
    }

    .social-links a:last-child {
        margin-right: 0;
    }

    .social-links:hover a {
        opacity: 0.7;
    }

    .social-links a:hover {
        opacity: 1;
    }

    .scroll {
        position: absolute;
        bottom: 0;
        margin-bottom: -20px;
        right: 15px;
        animation: scroll 1.5s infinite linear;
    }

    @keyframes scroll {
        0%{bottom: 0;}
        50%{bottom: 20px;}
        100%{bottom: 0;}
    }

    @media (max-width: 1400px) {
        .intro-title {
            font-size: 80px;
            line-height: 90px;
            margin: 0 0 35px;
        }

        .slide {
            padding: 60px 0 0;
            min-height: 585px;
        }

        .before-title {
            font-size: 18px;
            line-height: 24px;
        }

        .google-play {
            margin-bottom: 40px;
        }
    }

    @media (max-width: 1200px) {
        .intro-title {
            font-size: 56px;
            line-height: 70px;
            margin-bottom: 35px;
        }

        .google-play {
            margin-bottom: 45px;
        }

        .google-play img {
            width: 250px;
        }

        .slide {
            min-height: 520px;
        }
    }

    @media (max-width: 992px) {
        .intro-title {
            font-size: 46px;
            line-height: normal;
        }

        .main-intro {
            padding: 0;
        }

        .slide {
            min-height: 520px;
        }

        .social-links a {
            margin-right: 45px;
            font-size: 25px;
        }

        .instagram-icon {
            width: 25px;
        }
    }

    @media (max-width: 767px) {
        .intro-title {
            font-size: 56px;
            line-height: 76px;
            margin-bottom: 30px;
        }

        .main-intro {
            margin-top: 62px;
        }

        .slide {
            padding: 30px 0 0;
            margin-top: 0;
            height: calc(100vh - 62px);
            min-height: 480px;
        }

        .main-intro :global(.btn) {
            min-width: 180px;
        }

        .social-links {
            display: none;
        }

        .google-play {
            margin: 0 auto;
            width: 100%;
            text-align: center;
            padding: 12px 0;
        }

        .google-play img {
            width: auto;
        }

        .container {
            height: 100%;
        }

        .main-intro-content {
            height: 100%;
        }

        .slide-1 {
            background: var(--SlideGame1mobile) no-repeat center;
            background-size: cover;
        }

        .slide-2 {
            background: var(--SlideGame2mobile) no-repeat center;
            background-size: cover;
        }

        .slide-3 {
            background: var(--SlideGame3mobile) no-repeat center;
            background-size: cover;
        }

        .scroll {
            display: none;
        }

        .scroll img {
            width: 24px;
        }

        .before-title {
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 20px;
        }

        .google-play:hover {
            transform: none;
        }
    }
</style>
